module.exports = __webpack_public_path__ + "static/media/arrow-help.b325c0ed.svg";